import { cn } from '@/lib/cn'

const WORDMARK_SRC = '/assets/images/wordmark.png'

type SiteWordmarkProps = {
  className?: string
  /** Invert for dark backgrounds (e.g. site footer). */
  forDarkBg?: boolean
  loading?: 'eager' | 'lazy'
}

export function SiteWordmark({ className, forDarkBg, loading = 'eager' }: SiteWordmarkProps) {
  return (
    <img
      src={WORDMARK_SRC}
      alt="NK Our Town"
      loading={loading}
      decoding="async"
      className={cn('h-8 w-auto max-w-full object-contain object-left', forDarkBg && 'brightness-0 invert', className)}
    />
  )
}
